/**
 * Authentication Page Text Constants
 * Centralized text for easy updates, A/B testing, and future i18n support
 */

export const LOGIN_TEXT = {
  tagline: "Let's Talk Strategy",
  heading: "Welcome Back",
  subheading: "Sign in to access your tax strategies",
  emailPlaceholder: "Email address",
  passwordPlaceholder: "Password",
  rememberMe: "Remember me",
  forgotPassword: "Forgot password?",
  signInButton: "Sign In",
  signingInButton: "Signing in...",
  newUser: "New to BizHub?",
  createAccount: "Create Free Account",
  termsText: "By signing in, you agree to our",
  termsLink: "Terms",
  privacyLink: "Privacy Policy",
  registeredSuccess: "Account created! Please sign in.",
  verifiedSuccess: "Email verified! Please sign in.",
  and: "and"
};

export const SIGNUP_TEXT = {
  tagline: "Let's Talk Strategy",
  heading: "Create Your Account",
  subheading: "Join BizHub and start optimizing your tax strategy",
  namePlaceholder: "Full name",
  emailPlaceholder: "Email address",
  passwordPlaceholder: "Password",
  confirmPasswordPlaceholder: "Confirm password",
  signUpButton: "Create Account",
  signingUpButton: "Creating account...",
  existingUser: "Already have an account?",
  signInLink: "Sign In",
  termsText: "By signing up, you agree to our",
  termsLink: "Terms",
  privacyLink: "Privacy Policy",
  and: "and"
};

export const FORGOT_PASSWORD_TEXT = {
  tagline: "Let's Talk Strategy",
  heading: "Reset Password",
  subheading: "Enter your email to receive a reset link",
  emailPlaceholder: "Email address",
  submitButton: "Send Reset Link",
  sendingButton: "Sending...",
  backToLogin: "Back to Sign In",
  successMessage: "Reset link sent! Check your email."
};

export const ERROR_MESSAGES = {
  loginFailed: "Login failed. Please check your credentials.",
  signupFailed: "Signup failed. Please try again.",
  emailExists: "An account with this email already exists.",
  passwordMismatch: "Passwords do not match.",
  invalidEmail: "Please enter a valid email address.",
  weakPassword: "Password must be at least 8 characters.",
  networkError: "Network error. Please check your connection.",
  serverError: "Server error. Please try again later."
};
